import { Chip } from "@sidelinesports/fan-design-system";
import type { ApiGameDetails } from "../../../../api";
import { GAME_STATUS_LABELS } from "../../../../constants";
import styles from "./StatusTag.module.css";

export const StatusChip = ({ game }: { game: ApiGameDetails }) => {
  if (game.status === "upcoming" || game.status === "about_to_start") {
    return null;
  }

  const statusText = GAME_STATUS_LABELS[game.status];

  return (
    <Chip variant="fill-secondary" size="sm" className={styles.tag}>
      {statusText}
    </Chip>
  );
};
